import { inf_partner } from './inf_data';
import METODO_PAGO from "../../../dataComponets/metodo_pago copy.json";
import dayjs from 'dayjs';
import { formattedCurrentDate } from '../../../main_components/date/day';

const update_field_attributes = (
    accessor: string,
    attributes: {
        change?: boolean,
        required?: boolean,
        data_select?: any[],
        visible?: boolean
    }
) => {
    const field = inf_partner.find(item => item.accessor === accessor);

    if (field) {
        if (attributes.change !== undefined) {
            field.change = attributes.change;
        }
        if (attributes.required !== undefined) {
            field.required = attributes.required;
        }
        if (attributes.data_select !== undefined) {
            field.data_select = attributes.data_select;
        }
        if (attributes.visible !== undefined) {
            field.visible = attributes.visible;
        }
    } else {
        console.log(`No se encontró el campo con el accessor: ${accessor}`);
    }

    return inf_partner
};

export const updated_form_data = (key: any, value: any, formData: any) => {
    console.log(key);
    console.log(value);

    const update_form = {
        ...formData,
        [key]: value,
        business_partner: key === 'business_partner'
            ? value.business_partner
            : formData.business_partner,
        supplier_rfc: key === 'business_partner'
            ? value.rfc
            : formData.supplier_rfc,
        id_business_partner_fk: key === 'business_partner'
            ? value.id
            : formData.id_business_partner_fk,
        supplier_name: key === 'business_partner'
            ? value.business_partner
            : formData.supplier_name,
        form_of_payment: key === 'form_of_payment_code'
            ? METODO_PAGO.find((d) => d.value === value)?.label || "Valor no encontrado"
            : formData.form_of_payment,
    };

    console.log(update_form);
    return update_form;
};


export const validate_data = (name: string, value: any, formData: any, custom:any) => {
    var error = '';
    var regexEmail = /^\s*([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(\s*,\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})*\s*$/;
    var regexPhone = /^[0-9]{10}$/;
    var infPartner;


    

    switch (name) {
        case 'date_received_document':
            if (!value) {
                console.log(value)
                error = 'El campo "Fecha de entrega" es obligatorio.';
            }
            break;
    
        case 'business_partner':
            if (!value) {
                error = 'El campo "Proveedor" es obligatorio.';
            }
            break;
    
        case 'payment_method':
            if (!value) {
                error = 'El campo "Método de pago" es obligatorio.';
            }
            break;
    
        case 'outdoor_number':
            if (!value) {
                error = 'El campo "Número exterior" es obligatorio.';
            }
            break;
    
        case 'neighborhood':
            if (!value) {
                error = 'El campo "Colonia" es obligatorio.';
            }
            break;
    
        case 'zip_code':
            if (!value) {
                error = 'El campo "Código postal" es obligatorio.';
            }
            break;
    
        case 'city':
            if (!value) {
                error = 'El campo "Ciudad" es obligatorio.';
            }
            break;
    
        case 'town':
            if (!value) {
                error = 'El campo "Municipio" es obligatorio.';
            }
            break;
    
        case 'state':
            if (!value) {
                error = 'El campo "Estado" es obligatorio.';
            }
            break;
    
        case 'country':
            if (!value) {
                error = 'El campo "País" es obligatorio.';
            }
            break;
    
        case 'address_type':
            if (!value) {
                error = 'El campo "Tipo de dirección" es obligatorio.';
            }
            break;
    
        case 'subsidiary':
            if (!value) {
                error = 'El campo "Sucursal" es obligatorio.';
            }
            break;
    }
    

    return { error: error, objetUpdate: infPartner === undefined ? inf_partner : infPartner };
};


export const validate_data_email = (name: string, value: any, formData: any, custom:any) => {
    var error = '';
    var infPartner;
    return { error: error, objetUpdate: infPartner === undefined ? inf_partner : infPartner };
};




export const processed_format = (formData: any) => {
    const dataToSubmit = { ...formData };
    Object.keys(dataToSubmit).forEach((key) => {
        if (dataToSubmit[key] === "") {
            dataToSubmit[key] = null;
        }
        switch (key) {
            case 'date_received_document':
                dataToSubmit[key] = dayjs(dataToSubmit[key]).format('YYYY-MM-DD');
                break;

            case 'person_type':
                // Convertir la descripción a mayúsculas
                // dataToSubmit[key] = dataToSubmit[key].toUpperCase();
                break;

            // Agrega más casos según las necesidades de tu formulario
            default:
                // No hacer nada si no es un campo que necesita procesamiento especial
                break;
        }
    });

    return dataToSubmit;
};



export const create_object = {
    "order_number": "1",
    "date_received_document": dayjs(formattedCurrentDate),
    "payment_method": "PUE",
    "form_of_payment": "EFECTIVO (01)",
    "form_of_payment_code": "01",
    "id_business_partner_fk": null,
    "supplier_rfc": null,
    "supplier_name": null,
    "currency": "MXN",
    "exchange": 1,
    "total": null,
    "note": null,
    "details": [],
    "street": null,
    "outdoor_number": null,
    "inside_number": null,
    "neighborhood": null,
    "state": null,
    "zip_code": null,
    "address_type": null,
    "country": null,
    "city": null,
    "town": null,
    "reference": null,
    "subsidiary": null,
    "business_partner_options": [],
    "business_partner": null,
}





